import React, { Fragment } from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField/TextField";
import IconButton from "@material-ui/core/IconButton";
import ReplayIcon from "@material-ui/icons/Replay";

/* Text field with a reset button */
const TextSearchField = (props) => {
  const { label, name, value, onChange, resetValue } = props;
  return (
    <Fragment>
      <TextField
        label={label}
        name={name}
        value={value}
        type="text"
        onChange={onChange}
      />
      <IconButton color="primary" onClick={resetValue}>
        <ReplayIcon />
      </IconButton>
    </Fragment>
  );
};

TextSearchField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  resetValue: PropTypes.func.isRequired,
};

export default TextSearchField;



// WEBPACK FOOTER //
// ./src/components/Forms/TextSearchField.jsx